import { createRoute } from '@tanstack/react-router';
import { z } from 'zod/v3';

import { menuLayoutRoute } from 'root/MenuLayout';

import AnalyticsDashboardView from './AnalyticsDashboardView';
import { preloadDashboards } from './preload';
import { RedirectToIndexDashboard } from './RedirectToIndexDashboard';

const analyticsMainRoute = createRoute({
  getParentRoute: () => menuLayoutRoute,
  path: 'analytics',
});

const indexRoute = createRoute({
  getParentRoute: () => analyticsMainRoute,
  path: '/',
  loader: preloadDashboards,
  component: () => <RedirectToIndexDashboard />,
});

export const analyticsDashboardRoute = createRoute({
  getParentRoute: () => analyticsMainRoute,
  path: '$dashboardId',
  loader: preloadDashboards,
  parseParams: (params) => ({
    dashboardId: z.string().parse(params.dashboardId),
  }),
  component: () => <AnalyticsDashboardView />,
  validateSearch: z.object({
    dashboardParams: z.string().optional(),
  }).parse,
});

export const analyticsRouteTree = analyticsMainRoute.addChildren({
  indexRoute,
  analyticsDashboardRoute,
});
